import stateSettings from '@state/settings';
import Select from '@components/Select';
import * as React from 'react';
import { Divider, IconRow, InfoColumn, Title, TopBarBox } from './shared/_styles';
import FontSizeMutator from '@src/editor/Elements/TopBar/shared/FontSizeMutator';
import FontColorMutator from '@src/editor/Elements/TopBar/shared/FontColorMutator';
import StateMutator from '@src/editor/Elements/TopBar/shared/StateMutator';
import ZIndexMutator from '@src/editor/Elements/TopBar/shared/ZIndexMutator';
import { changeProperty } from '@src/actions';
import { getSelectedNode } from '@src/utils';
import AlignmentMutators from '@src/editor/Elements/TopBar/shared/AlingmentMutators';
const changeFontFamily = (fontFamilyId) => {
    changeProperty('fontFamilyId', fontFamilyId);
};
const TextMutators = () => {
    const component = getSelectedNode();
    return (React.createElement(TopBarBox, null,
        React.createElement(ZIndexMutator, null),
        React.createElement(Divider, null),
        React.createElement(AlignmentMutators, null),
        React.createElement(Divider, null),
        React.createElement(FontColorMutator, null),
        React.createElement(Divider, null),
        React.createElement(FontSizeMutator, null),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Font family"),
            React.createElement(IconRow, null,
                React.createElement(Select, { options: stateSettings.fonts.map((font) => font.id), value: component.fontFamilyId, toName: (id) => stateSettings.fonts.find((font) => font.id === id).fontFamily, onChange: changeFontFamily }))),
        React.createElement(StateMutator, null)));
};
export default TextMutators;
